(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/jotai/map-atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/jotai/map-atoms.js');
"use strict";


const {
  atom
} = jotai;
const {
  atomWithStorage
} = jotaiUtils;
setGlobal('svs.lyckoplatsen.shared_map.atoms', {
  isMovingAtom: atom(false),
  isCenteredAtom: atom(true),
  isUserIdleAtom: atom(false),
  mapZoomLevelAtom: atom(false),
  locationNameAtom: atomWithStorage('locationName', '')
});

 })(window);